import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { WAITING_TIME } from 'coreOld/constants';
import { useAppSelector } from 'coreOld/hooks';
import { useCompanyPartsActions } from 'partsOld/hooks';
import { mapCreatePartNotesToServer } from 'partsOld/mappers';
import { ICostNote, ISelectedNote } from 'partsOld/types';

import AddCostNoteView from './AddCostNoteView';

interface IProps {
  setIsAddCostOpen?: Dispatch<SetStateAction<boolean | ISelectedNote>>;
  setEditedNote?: Dispatch<SetStateAction<ICostNote>>;
  isAddCostOpen?: boolean;
  selectedNote?: ISelectedNote;
  selectedItems?;
  setCloseSelection?: Dispatch<SetStateAction<boolean>>;
  companyPartFilters?: Record<string, any>;
}

const AddCostNote = ({
  setIsAddCostOpen,
  isAddCostOpen,
  selectedItems,
  selectedNote,
  setEditedNote,
  setCloseSelection,
  companyPartFilters,
}: IProps) => {
  const { selectionMode } = useAppSelector((state) => state.table);
  const [noteContent, setNoteContent] = useState('');

  const { addCostNote, editCostNote } = useCompanyPartsActions();

  useEffect(() => {
    if (selectedNote) {
      setNoteContent(selectedNote?.costNote);
    }
  }, [selectedNote]);

  useEffect(() => {
    if (noteContent && !isAddCostOpen) {
      setNoteContent('');
    }
  }, [isAddCostOpen]);

  const onCreateNote = async () => {
    await addCostNote(
      mapCreatePartNotesToServer(noteContent, selectedItems, selectionMode, companyPartFilters)
    );

    if (setCloseSelection) {
      setCloseSelection(true);
    }

    setTimeout(() => {
      setIsAddCostOpen(false);
    }, WAITING_TIME);
  };

  const onEditNote = async () => {
    const note = await editCostNote({
      id: selectedNote?.costNoteId,
      content: noteContent,
    });

    setEditedNote(note);

    setTimeout(() => setIsAddCostOpen(false), WAITING_TIME);
  };

  const onCloseModal = () => {
    setIsAddCostOpen(false);
  };

  return (
    <AddCostNoteView
      isAddCostOpen={isAddCostOpen}
      selectedNote={selectedNote}
      noteContent={noteContent}
      setNoteContent={setNoteContent}
      onCreateNote={onCreateNote}
      onEditNote={onEditNote}
      onCloseModal={onCloseModal}
    />
  );
};

export default AddCostNote;
